import type {FC} from 'react';

import type {MediaFragment} from '@/schema/primitives/media';

import {MediaImage} from './image';
import type {MaskVariant} from './shared';
import {MediaVideo} from './video';
import {MediaVideoOriginal} from './video-original';

interface Props {
	media?: MediaFragment;
	itemGalleryFirstMask?: MaskVariant;
	disabledMask?: boolean;
	disabledControls?: boolean;
}

export const Media: FC<Props> = ({
	media,
	itemGalleryFirstMask,
	disabledMask,
	disabledControls,
}) => {
	if (media?.type === 'image' && 'image' in media && media.image?.asset) {
		return (
			<MediaImage
				image={media.image}
				itemGalleryFirstMask={itemGalleryFirstMask}
				disabledMask={disabledMask}
			/>
		);
	} else if (
		media?.type === 'video' &&
		'video' in media &&
		media.video?.videoId &&
		media.video?.mask !== 'original'
	) {
		return (
			<MediaVideo
				video={media.video}
				itemGalleryFirstMask={itemGalleryFirstMask}
				disabledControls={disabledControls}
				disabledMask={disabledMask}
			/>
		);
	} else if (
		media?.type === 'video' &&
		'video' in media &&
		media.video?.videoId &&
		media.video?.mask === 'original'
	) {
		return (
			<MediaVideoOriginal
				video={media.video}
				disabledControls={disabledControls}
			/>
		);
	}

	return null;
};
